import React, { useContext, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { RootStoreContext } from "../../../../../app/stores/rootStore";

const MyTemplates = ({ projectId }) => {
  const navigate = useNavigate();
  const { screeningStore } = useContext(RootStoreContext);
  const { myTemplates, loadingWorkflows, fetchWorkflows } = screeningStore;

  useEffect(() => {
    fetchWorkflows(projectId);
  }, [projectId, fetchWorkflows]);

  return (
    <div className="fadein animation-duration-500" style={{ display: "flex", flexDirection: "column", flex: 1 }}>
      <div className="screening-header">
        <span className="screening-header-icon">📋</span>
        <span className="screening-header-title">My Templates</span>
        <div className="screening-header-buttons">
          <Button label="Save Current as Template" icon="pi pi-save" className="screening-header-btn" />
        </div>
      </div>

      <div className="screening-body">
        {loadingWorkflows ? (
          <div className="screening-empty">
            <div className="screening-empty-text">Loading...</div>
          </div>
        ) : myTemplates.length === 0 ? (
          <div className="screening-empty">
            <div className="screening-empty-icon">📋</div>
            <div className="screening-empty-text">No templates yet</div>
            <div className="screening-empty-sub">Save a workflow as a template to reuse it later</div>
          </div>
        ) : (
          <div className="screening-template-grid">
            {myTemplates.map((t, i) => (
              <div key={t.id || i} className="screening-template-card">
                <div className="screening-template-name">📄 {t.name}</div>
                <div className="screening-template-meta">
                  Nodes: {t.nodeCount} · Used: {t.useCount} times · Last: {new Date(t.lastEditAt).toLocaleDateString()}
                </div>
                <div className="screening-template-actions">
                  <Button label="Use" icon="pi pi-play" className="p-button-sm"
                    onClick={() => navigate(`editor/${t.id}`)}
                    style={{ background: "#4f46e5", border: "none", borderRadius: 4, fontSize: "0.8rem" }} />
                  <Button label="Edit" icon="pi pi-pencil" className="p-button-sm p-button-outlined"
                    style={{ borderRadius: 4, fontSize: "0.8rem" }} />
                  <Button label="Share" icon="pi pi-share-alt" className="p-button-sm p-button-text"
                    style={{ borderRadius: 4, fontSize: "0.8rem" }} />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default observer(MyTemplates);
